import React from 'react'
import moment from 'moment'
import { Badge } from '@/components/ui/badge'
import Timeago from '../../../../../timeago'

// A tutor's circumvention incidents, read-only, in the Warnings tab. They come
// with the tutor's full result (viewing the tutor); the list rows only carry
// ids and outcomes, so nothing shows here until the full result has loaded.
// False alarms are left out by the API.
class TutorResultCircumventionIncidents extends React.Component {

  render() {
    const incidents = (this.props.tutor_result.circumvention_incidents || []).filter((incident) => incident.summary)

    if (incidents.length === 0) {
      return null
    }

    return (
      <div className="flex flex-col gap-2">
        {incidents.map((incident) =>
          <div key={incident.id} className="rounded-[10px] border border-border bg-card px-4 py-3">
            <div className="flex items-center gap-2 text-sm font-semibold">
              <Badge variant={incident.outcome === 'verified' ? 'destructive' : 'warning'}>
                {incident.outcome === 'verified' ? 'Circumvention verified' : 'Circumvention pending'}
              </Badge>
              <Timeago date={incident.created_at}/>
              <span className="ml-auto font-normal text-muted-foreground">
                {incident.lesson_id ? `Lesson #${incident.lesson_id}` : `Meeting #${incident.meeting_id}`}
                {incident.customer_name ? ` · ${incident.customer_name}` : ''}
              </span>
            </div>
            <div className="mt-2 text-sm">{incident.summary}</div>
            <div className="mt-2 whitespace-pre-wrap rounded-lg bg-muted p-3 text-xs leading-relaxed">{incident.snippet}</div>
            <div className="mt-1 text-xs text-muted-foreground">{moment(incident.created_at).format('D MMM YYYY, HH:mm')}</div>
          </div>
        )}
      </div>
    )
  }
}

export default TutorResultCircumventionIncidents
